import { getWindow } from '../getWindow';

export type Bounds = {
  width: number;
  height: number;
};

// Define a type with the window properties we need
interface WindowWithViewport {
  innerWidth: number;
  innerHeight: number;
  visualViewport?: {
    width: number;
    height: number;
  };
}

export const getWindowBounds = (
  win: WindowWithViewport = (getWindow() as unknown) as WindowWithViewport
): Bounds => {
  const viewport = win.visualViewport;

  return {
    width:
      viewport?.width !== undefined
        ? Math.min(win.innerWidth, viewport.width)
        : win.innerWidth,

    height:
      viewport?.height !== undefined
        ? Math.min(win.innerHeight, viewport.height)
        : win.innerHeight,
  };
};
